import React from 'react';
import { Icon } from '@iconify/react';

const DashboardHeader = ({ onRefresh, isDark, onToggleDarkMode }) => (
  <div className="space-y-2">
    <div className="flex justify-between items-center">
      <h1 className="text-3xl font-bold text-blue-900 dark:text-blue-300">MyODS Analytics</h1>
      <div className="flex items-center gap-4">
        <div className="text-xl font-bold text-black dark:text-gray-100">MyODS</div>
        <button
          onClick={onToggleDarkMode}
          className="relative w-12 h-6 bg-gray-300 dark:bg-gray-600 rounded-full flex items-center px-1 transition-colors duration-300"
          aria-label="Toggle dark mode"
          title="Toggle dark mode"
        >
          <div
            className={`w-5 h-5 rounded-full bg-white shadow-md transform transition-transform duration-300 ${
              isDark ? 'translate-x-6' : 'translate-x-0'
            }`}
          />
          <span className="absolute left-1 text-xs">
            <Icon icon={isDark ? 'fluent-emoji:crescent-moon' : 'fluent-emoji:sun'} className="h-4 w-4" aria-hidden="true" />
          </span>
        </button>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          onClick={onRefresh}
        >
          REFRESH DATA
        </button>
      </div>
    </div>
    <p className="block w-full text-left text-xs text-slate-600 dark:text-slate-300">
      Time-based charts are aggregated using each selected location&apos;s local timezone.
    </p>
  </div>
);

export default DashboardHeader;
